import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { EmburseThemeProvider } from '@emburse/embark-core';
import { EmburseLocaleProvider } from '@emburse/embark-locale';
const renderEmbarkComplex = (Component, props, mountNodeId) => {
    // updating the default breakpoints so that mobile size starts at 960, mobile sidebar with backdrop,
    // which is what is being used in the rest of the app
    const breakpointToken = {
        breakpoints: {
            values: {
                lg: 1280,
                md: 960,
                sm: 960,
                xl: 1920,
                xs: 0
            }
        }
    };
    const container = document.getElementById(mountNodeId);
    const root = createRoot(container);
    root.render(_jsx(EmburseThemeProvider, { designToken: breakpointToken, children: _jsx(EmburseLocaleProvider, { children: _jsx(Component, { ...props }) }) }));
};
export default renderEmbarkComplex;
